import { gql } from "@apollo/client";

export const GET_PROFESIONAL_LOGGED = gql`
query GetProfesionalLogged {
    profesionalByIdUsuario {
        idProfesional
        idTipoProfesional
    }
}`;